import { useCallback, useEffect, useRef, useState } from "react";

interface UseSinglyConcurrentAsyncActionOptions {
  onError?: (error: Error) => void;
  onSuccess?: () => void;
}

const useSinglyConcurrentAsyncAction = (
  options: UseSinglyConcurrentAsyncActionOptions = {},
) => {
  const [isPending, setIsPending] = useState(false);
  const isPendingRef = useRef<boolean>(isPending);
  useEffect(() => {
    isPendingRef.current = isPending;
  }, [isPending]);

  const execute = useCallback(
    async (asyncFn: () => Promise<void>) => {
      if (isPendingRef.current) return;

      setIsPending(true);
      try {
        await asyncFn();
        options.onSuccess?.();
      } catch (error) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- legitimate use case
        options.onError?.(error as Error);
      } finally {
        setIsPending(false);
      }
    },
    [options],
  );

  return {
    execute,
    isPending,
  };
};

export default useSinglyConcurrentAsyncAction;
